module.exports = window.__federationLoadRemote("moduleUi");